import service from '../service.js'

export default{

    addEmployment(){
        return service.get('module')
    },

    getHistory(employee_key){
        return service.get('employment-info',{
            employee_key : employee_key
        });
    },
    addOutsideCompany(emp_key,company_name,position,start_date,end_date){
        return service.post('employment-history',
            {
                emp_key         : emp_key,
                company_name    : company_name,
                position        : position,
                start_date      : start_date,
                end_date        : end_date
        })
    },
    addInsideCompany(emp_key,division,department,section,position,start_date,end_date){
        return service.post('service-record',
            {
                emp_key         : emp_key,
                division        : division,
                department      : department,
                section         : section,
                position        : position,
                start_date      : start_date,
                end_date        : end_date
        })
    },
}
